import {Component, EventEmitter, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, Validators} from "@angular/forms";

export enum AddEquityInstallmentMode {
  INSTALLMENT = 'installment',
  FUNDING = 'funding',
  APPROVAL = 'approval',
  CONDITION = 'condition'
}

@Component({
    selector: 'app-add-installment-funding-modal',
    templateUrl: './add-installment-funding-modal.component.html',
    styleUrls: ['./add-installment-funding-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddInstallmentFundingModalComponent implements OnInit{
  public save: EventEmitter<any> = new EventEmitter<any>()
  public title: string = ""
  public installmentForm:FormGroup = new FormGroup<any>({
    project_id: new FormControl(null),
    installment_number: new FormControl(null),
    installment_amount: new FormControl(null, [Validators.required]),
    original_commitment_date: new FormControl(null, [Validators.required]),
  })

  public approvalForm:FormGroup = new FormGroup<any>({
    approval_type: new FormControl(null, [Validators.required]),
  })

  public conditionForm: FormGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    nickname: new FormControl(null),
    notes: new FormControl(null),
  })

  public currentForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data:any, private dialogRef: MatDialogRef<any>) {

  }

  ngOnInit() {
    this.title = this.data.modalType.toUpperCase()
    if(this.data.modalType==AddEquityInstallmentMode.INSTALLMENT){
      this._setInstallmentForm()
    }
    if(this.data.modalType==AddEquityInstallmentMode.APPROVAL){
      this.currentForm = this.approvalForm
    }
    if(this.data.modalType==AddEquityInstallmentMode.CONDITION){
      this.currentForm = this.conditionForm
    }
  }

  private _setInstallmentForm(){
    this.installmentForm.controls['project_id'].setValue(this.data.projectId)
    this.currentForm = this.installmentForm
  }


  public onSave(event:any){
    this.save.emit(this.currentForm.getRawValue())
  }

  public close(event:any){
    event.preventDefault();
    this.dialogRef.close()
  }

  protected readonly AddEquityInstallmentMode = AddEquityInstallmentMode;
}
